import { useContext } from 'react'
import { useState, useEffect } from 'react'
import upperFirst from 'lodash/upperFirst'
import cssVariables from '#src/assets/styles/breakpoints.values.css'
import { UserAgentContext } from '#src/containers/UserAgent'
import useGetEstimatedDeviceWidth from './useGetEstimatedDeviceWidth'
// @ts-ignore
import mediaQuery from 'css-mediaquery'

export default function useBreakpoint(breakpointName: string) {
  const ua = useContext(UserAgentContext)

  const estimatedDeviceWidth = useGetEstimatedDeviceWidth(ua)

  const mediaQueryFeature = cssVariables[`mBreakpoint${upperFirst(breakpointName)}`]

  const isMatch = mediaQuery.match(mediaQueryFeature, {
    width: estimatedDeviceWidth
  })

  /**
   * First render should use the value determined by SSR to ensure there are no differences during hydration
   */
  const [matches, setMatches] = useState<boolean>(isMatch)

  useEffect(() => {
    /**
     * Older (very old) feature phones and browsers may not have matchMedia on the window object
     * https://caniuse.com/#feat=matchmedia
     **/
    if (!window.matchMedia) {
      return
    }

    const mediaQueryList = window.matchMedia(mediaQueryFeature)

    const listener = () => {
      if (mediaQueryList.matches) {
        setMatches(true)
      } else {
        setMatches(false)
      }
    }

    mediaQueryList.addListener(listener)
    setMatches(mediaQueryList.matches)

    return () => mediaQueryList.removeListener(listener)
  }, [breakpointName])

  return matches
}
